<template>
  <base-dialog
    okText="保存"
    cancelText="关闭"
    @change="$emit('closeDiag')"
    @ok="saveData"
    width="70%"
    style="height: 100%"
    title="编辑数据列"
    append-to-body
    v-model="visiable"
  >
    <div style="min-height: 300px">
      <base-form
        ref="baseFieldForm"
        class="baseFieldFormCss"
        v-model="baseFieldFormObj"
        labelWidth="auto"
        :inline="true"
        :form-items="baseFormItems"
      >
      </base-form>
      <base-form
        class="fieldsFormCss"
        v-for="(formItems, index) in fieldsItemForms"
        :key="index"
        v-model="fieldsFormObj[index]"
        :form-items="formItems"
        labelWidth="auto"
        :inline="true"
        :rules="rules"
      ></base-form>
      <div style="width: 100%; text-align: center">
        <el-button
          style="width: 100px"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addClick"
        ></el-button>
      </div>
    </div>
  </base-dialog>
</template>
<script>
export default {
  name: 'field-add-dialog',
  props: {
    baseObj: Object,
    value: Boolean
    // placement:{
    //   type:String,
    //   default:'top-start'
    // },
    // effect:{
    //   type:String,
    //   default:'dark'
    // },
    // contentKey:{
    //   type:String,
    //   default:'content'
    // },
  },
  data() {
    var options = []
    for (var i = 1; i <= 20; i++) {
      options.push({
        label: i,
        value: i
      })
    }
    var baseFieldFormItem = [
      {
        label: '列名称',
        prop: 'clum_desc',
        bind: {
          width: '32%'
        }
      },
      {
        label: '查询列',
        prop: 'query_clum',
        component: 'el-switch',
        bind: {
          activeValue: true,
          inactiveValue: false
          // activeText:'是',
          // inactiveText:'否',
        }
      },
      {
        label: '文本框',
        prop: 'ele_type',
        component: 'el-switch',
        bind: {
          activeValue: true,
          inactiveValue: false
          // activeText:'文本框',
          // inactiveText:'选择框',
        }
      },
      {
        label: '隐藏列',
        prop: 'clum_disabled',
        component: 'el-switch',
        bind: {
          activeValue: true,
          inactiveValue: false
        }
      },
      {
        label: '排序值',
        prop: 'clum_sort',
        component: 'form-select',
        bind: {
          options: options
        }
      },
      {
        label: '',
        prop: 'btn',
        component: 'el-button',
        bind: {
          label: '',
          value: 0,
          icon: 'el-icon-delete',
          type: 'primary'
        },
        on: {
          click: this.deleteField
        }
      }
    ]
    return {
      baseFieldFormObj: {
        brand: '',
        type: '',
        lang: 'CN'
      },
      baseFormItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select',
          bind: {
            options: this.$getOptions('queryType'),
            disabled: true,
            style: 'width: 200px'
          }
        },
        {
          label: '语言',
          prop: 'lang',
          component: 'form-select',
          bind: {
            options: this.$getOptions('lang'),
            disabled: true,
            style: 'width: 200px'
          }
        },
        {
          label: '类别名称',
          prop: 'brand',
          component: 'form-select1',
          bind: {
            style: 'width: 200px',
            param: {
              data_type: 1
            },
            sendJson: true,
            dataKey: {
              label: 'brand',
              value: 'id'
            },
            disabled: true
          },
          on: {
            change: (obj) => {
              this.$nextTick(() => {
                this.drawer.$refs.drawer.form.brand = obj.lab
              })
            }
          }
        }
      ],
      fieldsItemForm: baseFieldFormItem,
      fieldsItemForms: [],
      fieldsFormObj: [],
      rules: {
        clum_desc: [
          {
            required: true,
            message: '请输入列名称',
            trigger: 'blur'
          }

          // {
          //   validator:(rule, value,callback)=>{
          //     if(!/^[A-Za-z][0-9a-zA-Z_-]{1,}$/.test(value)){
          //       callback("必须由字母开头并且只能含有字母、数字、_、-字符");
          //       return;
          //     }
          //     callback();
          //   },
          //   trigger: 'blur',
          //   required: true,
          // }
        ],
        clum_sort: [
          {
            required: true,
            message: '请选择排序值',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('closeDiag')
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$nextTick(() => {
        var fields = this.baseObj.fields
        this.baseFieldFormObj.brand = this.baseObj.brand
        this.baseFieldFormObj.type = this.baseObj.type
        this.baseFieldFormObj.lang = this.baseObj.lang
        if (fields && fields.length > 0) {
          for (var field of fields) {
            this.addField(field)
          }
          var newFieldsObj = []
          for (var fieldObj of this.fieldsFormObj) {
            newFieldsObj.push({ ...fieldObj })
          }
          this.$nextTick(() => {
            //刷新
            this.fieldsFormObj = newFieldsObj
          })
        }
      })
    },
    updSortVal(val) {
      // console.log(val)
      // var idx = event.currentTarget.dataset.idx
      // this.setSortOpts(val, this.fieldsItemForms[idx])
    },
    setSortOpts(val, obj, isAy) {
      // var newOptions=[];
      // var startNo=1,endNo=10;
      // if(!val){
      //     startNo=11,endNo=30;
      // }
      // for(var i=startNo;i<=endNo;i++){
      //     newOptions.push({
      //         label:i,
      //         value:i
      //     })
      // }
      // //刷新数据展示
      // if(isAy){
      //   obj[obj.length-2].bind.options=newOptions;
      // }else{
      //   this.$nextTick(()=>{
      //     obj[obj.length-2].bind.options=newOptions;
      //     obj[obj.length-2].value='';
      //   })
      // }
    },
    addClick() {
      var obj = { bid: this.baseObj.bid, data_type: 2 }
      Object.assign(obj, this.baseFieldFormObj)
      this.addField(obj)
    },
    addIdxMarkAndEvt(newArr, idx, evtName, evt) {
      newArr[idx].bind['data-idx'] = this.fieldsItemForms.length
      var onEvt = {}
      onEvt[evtName] = evt
      newArr[idx].on = onEvt
    },
    addField(obj) {
      obj.cre_user = this.$root.getNickName()
      var newArr = JSON.parse(JSON.stringify(this.fieldsItemForm))
      // for(var obj of newArr){
      //   obj.prop=obj.prop+(newArr.length-1);
      // }
      //按钮点击事件
      this.addIdxMarkAndEvt(
        newArr,
        newArr.length - 1,
        'click',
        this.deleteField
      )
      //查询列切换事件
      this.addIdxMarkAndEvt(newArr, 1, 'change', this.updSortVal)
      this.setSortOpts(obj.query_clum, newArr, true)
      this.fieldsFormObj.push(obj)
      this.fieldsItemForms.push(newArr)
    },
    deleteField(obj) {
      var idx = obj.currentTarget.dataset.idx
      this.fieldsFormObj.splice(idx, 1)
      this.fieldsItemForms.splice(idx, 1)
    },
    saveData() {
      //验证数据填写
      for (var obj of this.fieldsFormObj) {
        obj.cre_user = this.$root.getNickName()
        obj.bid = this.baseObj._id
        if (!obj.clum_desc) {
          this.$message('不能存在空列')
          return
        }
        if (!obj.clum_sort) {
          this.$message('排序值不为空')
          return
        }
      }
      this.baseObj.data_type = 2
      this.baseObj.fields = this.fieldsFormObj
      this.$postObj('/brandOrField/add', this.baseObj)
        .then((resp) => {
          if (resp.data.code == 0) {
            this.visiable = false
            this.$message({
              type: 'success',
              message: '编辑成功'
            })
            this.$emit('editSuccess')
          } else {
            console.error(resp)
            this.$message(
              resp.data.msg || this.$getMsg(resp.data.code, '服务端处理失败')
            )
          }
        })
        .catch((error) => {
          // 请求失败处理
          console.error(error)
          this.$message('请求发生错误！')
        })
    }
    // refreshOption(val){
    //     var baseFormItemNew={...this.baseFormItem};
    //     baseFormItemNew.bind.url="/brandOrField/get";
    //     baseFormItemNew.bind.param.type=val;
    //     return baseFormItemNew;
    // },
    // formTypeChange(obj){
    //     var that=this;
    //     var baseFormItemNew=this.refreshOption(obj.val);
    //     this.baseFormItems.splice(1,1);
    //     this.$nextTick(()=>{
    //         this.baseFormItems.splice(1,0,baseFormItemNew);
    //         this.baseFormItems[0].value=obj.val;
    //     })
    // },
  }
}
</script>
<style lang="stylus" scoped>
.fieldsFormCss {
  min-width: 800px;
}

>>>.baseFieldFormCss .el-form-item__content {
  width: 70%;
}
</style>
